<div *ngIf="show" class="loader">
    <span class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></span> <span class="loader-text">{{text}}</span>
</div>